module.exports = __webpack_public_path__ + "static/media/step4b.695438d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tour/assets/step4b.png
// module id = 3743
// module chunks = 0